import { useRouter } from "next/navigation";

import { useAppDispatch } from "@/store/hook";
import { setMedicalData } from "@/store/slices/medical.slice";
import { GetQuoteFilter } from "@/store/slices/quote/API/getQuote";
import { getQuoteData } from "@/store/slices/quote/quote.action";
import { QuoteData } from "@/types/quote/quote-data";

const useResetStateEdit = () => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const resetQuestionData = async () => {
    const getQuoteFilter: GetQuoteFilter = {
      affiliate: null,
      quoteId: null,
      policy: null,
    };
    await dispatch(getQuoteData({ getQuoteFilter, router, dispatch })).then(
      (res) => {
        if (res.meta.requestStatus === "fulfilled") {
          const payload = res.payload as QuoteData;
          if (payload.attributes?.travellerDetails?.gateKeeperAnswers) {
            dispatch(
              setMedicalData({
                ...payload.attributes?.travellerDetails?.gateKeeperAnswers,
              })
            );
          }
        }
      }
    );
  };

  return {
    resetQuestionData,
  };
};

export default useResetStateEdit;
